import React, {useState, useRef, useEffect} from 'react';
import { Link } from 'react-router-dom';
import Logo from '../components/LogoHeader'
import HamburgerIcon from '../components/icons/HamburgerIcon'
import CloseIcon from '../components/icons/CloseIcon'
import ThemeToggle from '../components/ThemeToggle'

const GuestHeader = () => {

    const [open, setOpen] = useState(false)
    const navRef = useRef(null);
    const buttonRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (open && !navRef.current?.contains(e.target) && !buttonRef.current?.contains(e.target)) {
                setOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [open]);

    return (
        <>
            <header className="w-full px-5 h-[60px] flex fixed justify-between items-center border-b border-custom-charcoal bg-custom-dark z-50">
            <div className='inline-block'>
                <Logo />
            </div>
            <div className="flex gap-3 sm:gap-4 md:gap-5 items-center">
                <button ref={buttonRef} className="cursor-pointer" type="button" onClick={() => setOpen(!open)}>
                    {open ? (<CloseIcon />) : (<HamburgerIcon />)}
                </button>
            </div>
            </header>
            <nav 
                ref={navRef}
                className={
                    `fixed top-[60px] w-full h-[100vh] bg-custom-darker sm:max-w-[300px] z-[1000] text-lg sm:text-sm
                    ${open ? 'right-0' : 'right-[-100%]'}
                    transition-all ease-in-out duration-500 border-l border-custom-charcoal`
                }
            >
                <ul>
                    <li>
                        <Link to="/register" className='block w-full px-5 py-4 border-b border-custom-charcoal'>Sign Up</Link>
                    </li>
                    <li>
                        <Link to="/login" className='block w-full px-5 py-4 border-b border-custom-charcoal'>Log In</Link>
                    </li>
                    <li>
                        <Link to="/support" className='block w-full px-5 py-4 border-b border-custom-charcoal'>Support</Link>
                    </li>
                    <li>
                        <ThemeToggle />
                    </li>
                </ul>
            </nav>
        </>
    );
};

export default GuestHeader;
